import { render, staticRenderFns } from "./CreateSingleCategoryDashboard.vue?vue&type=template&id=3553d00c&scoped=true&"
import script from "./CreateSingleCategoryDashboard.vue?vue&type=script&lang=js&"
export * from "./CreateSingleCategoryDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CreateSingleCategoryDashboard.vue?vue&type=style&index=0&id=3553d00c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3553d00c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
